import styled from 'styled-components'

import { RoundedModal } from '../RoundedModal/RoundedModal'

export const NoUserModal = styled(RoundedModal)`
    .modal-header {
        background: ${({ theme }) => theme['yellow-500']};
    }

    .button-save {
        background: ${({ theme }) => theme['yellow-500']};
        color: ${({ theme }) => theme['gray-1000']};
      border: none;
    }

    .button-cancel {
        background: ${({ theme }) => theme['gray-0']};
    }
`
